<div class="d-flex align-items-stretch auth auth-img-bg h-100">
  <div class="row flex-grow">
    <div class="col-md-6 d-flex align-items-center justify-content-center">
      <div class="auth-form-transparent text-start p-3">
        <div class="brand-logo">
          <img src="assets/images/logo.png" alt="logo">
        </div>

        <h4>Welcome back!</h4>
        <h6 class="fw-light">Happy to see you again!</h6>

        <form class="pt-3" [formGroup]="loginForm">
          <div *ngIf="errorMessage" class="alert alert-danger">
            {{ errorMessage }}
          </div>

          <div class="form-group">
            <label for="email">E-mail</label>
            <div class="input-group">
              <div class="input-group-prepend bg-transparent">
                <span class="input-group-text bg-transparent border-right-0">
                  <i class="mdi mdi-account-outline text-primary"></i>
                </span>
              </div>
              <input type="email" formControlName="email" class="form-control form-control-lg border-left-0" id="email" placeholder="You're email address">
            </div>
          </div>

          <div class="form-group">
            <label for="password">Password</label>
            <div class="input-group">
              <div class="input-group-prepend bg-transparent">
                <span class="input-group-text bg-transparent border-right-0">
                  <i class="mdi mdi-lock-outline text-primary"></i>
                </span>
              </div>
              <input type="password" formControlName="password" class="form-control form-control-lg border-left-0" id="password" placeholder="You're password">
            </div>
          </div>

          <!--<div class="my-2 d-flex justify-content-between align-items-center">
            <div class="form-check">
              <label class="form-check-label text-muted">
                <input type="checkbox" class="form-check-input">
                <i class="input-helper"></i>
                Keep me signed in
              </label>
            </div>
            <a href="javascript:(void)" class="auth-link text-black">Forgot password?</a>
          </div>-->

          <div class="my-3 d-grid gap-2">
            <button class="btn btn-block btn-primary btn-lg fw-medium auth-form-btn"
                    (click)="login()"
                    [disabled]="loginForm.invalid">LOGIN</button>
          </div>
        </form>
      </div>
    </div>
    <div class="col-md-6 login-half-bg d-flex flex-row">
    </div>
  </div>
</div>
